<template>
	<div class="shaorenhuayunwei2th">
		<title1 type="1" title="少人化运维" style="margin-top: -68px" />
		<div class="shaorenhuayunwei2th-box">
			<div class="left">
				<div class="img-box">
					<img class="under" src="@/assets/images/exposition/shuzigongchangdongxiao.png" alt="">
					<img class="above" src="@/assets/images/exposition/guzhangfashenglv.png" alt="">
				</div>
				<div class="text-box">
					<div class="top DS-Digital-Bold">
						<img src="@/assets/images/exposition/xiadiao.png" alt="">
						40%
					</div>
					<div class="bottom">
						故障发生率
					</div>
				</div>
			</div>
			<div class="right">
				<div class="img-box">
					<img class="under" src="@/assets/images/exposition/shuzigongchangdongxiao.png" alt="">
					<img class="above" src="@/assets/images/exposition/renlichengben.png" alt="">
				</div>
				<div class="text-box">
					<div class="top DS-Digital-Bold">
						<img src="@/assets/images/exposition/xiadiao.png" alt="">
						50%
					</div>
					<div class="bottom">
						人力成本
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import divBox2 from '@/views/mobile/components/divbox2'
	import MyEcharts from '@/views/exposition/components/charts/echarts.vue'
	import * as echarts from 'echarts5'
	import title1 from '@/views/exposition/components/title2'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		components: {
			divBox2,
			MyEcharts,
			title1
		},
		data() {
			return {
				showcdata: false,
				// title:"车辆新增及活跃趋势",
				cdata: {}
			};
		},
		destroyed() {},
		mounted() {},
		methods: {}

	}
</script>

<style lang="scss" scope>
	.shaorenhuayunwei2th {
		width: 650px;
		height: 350px;
		.shaorenhuayunwei2th-box{
			display: flex;
			display: flex;
			padding-top: 70px;
			>div{
				flex: 1;
				display: flex;
				padding-left: 20px;
				.img-box{
					width: 120px;
					height: 120px;
					position: relative;
					img{
						width: 100%;
						height: 100%;
					}
					.above{
						width: 50px;
						height: 50px;
						position: absolute;
						left: 35px;
						top: 35px;
					}
				}
				.text-box{
					padding-left: 20px;
					text-align: right;
					.top{
						height: 60px;
						line-height: 55px;
						font-size: 48px;
						color: #DFAB29;
						img{
							width: 30px;
							height: 30px;
							margin-top: -1px;
						}
					}
					.bottom{
						line-height: 58px;
						font-size: 28px;
					}
				}
			}
		}
	}
</style>